const cardWidth = 350;
const cardGutter = 25;
const cardHeight = 450;

const academyStyles = {
  card: {
    cardWidth,
    cardGutter,
    cardHeight,
  },
  common: {
    maxWidth: cardWidth * 3 + cardGutter * 4,
    contentTypeIconColor: '#697788',
  },
  header: {
    headerHeight: 110,
    headerShorterHeight: 110,
  },
  mediaQueries: {
    collapseToTwoColumnsAt: `@media (max-width: ${cardWidth * 3 + cardGutter * 8}px)`,
    collapseToOneColumnAt: `@media (max-width: ${cardWidth * 2 + cardGutter * 6}px)`,
    twoColumnMaxWidth: `${cardWidth * 2 + cardGutter * 2}px`,
    oneColumnMaxWidth: `${cardWidth}px`,
  },
};

export const color = {
  certPassed: '#4ABF4A', // Old color: #8DC640
  certFailed: '#ED3E31', // Old color: #D1403F
  certRequiresGrading: '#FCDC5F',
  neutralGrey: '#d3d3d3',
  inProgress: '#203a8e',
};

export const certOverviewContent = {
  paddingLeftRight: '3rem',
  paddingLeftRightDesktopMedium: '2rem',
  paddingLeftRightMobile: '1.5rem',
};

export default academyStyles;
